import { Row, Col, Collapse, Card, CardHeader, CardBody } from "reactstrap";
import { CommittedLoad } from "../../model/viewModel/committedLoad";
import CommittedLoadConnectionWarning from "./CommittedLoadConnectionWarning";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { committedLoadFilter } from "../../utils/committedLoadFunctions";
import { useState } from "react";
import Feature from "../feature-flag/Feature";

interface CommittedLoadDisplayProps {
  committedLoad: CommittedLoad;
}

const CommittedLoadDisplay = ({ committedLoad }: CommittedLoadDisplayProps) => {
  const [isCommittedLoadOpen, setIsCommittedLoadOpen] = useState(true);

  const includeCommittedLoadQuotationSent = useSelector(
    (state: RootState) => state.settings.isIncludeCommittedLoadQuotationSentEnabled,
  );

  const getChevronIcon = (open: boolean) => `icon-chevron-${open ? "down" : "right"}`;

  const filteredCommittedLoad =
    committedLoad?.connections?.filter((item) =>
      committedLoadFilter(item, includeCommittedLoadQuotationSent),
    ) ?? [];

  return (
    <Feature flag="UseAcceptToConnectDataEnabled">
      {filteredCommittedLoad.length > 0 && (
        <>
          <Card className="border-warning bg-dark mb-3">
            <CardHeader
              className="bg-warning"
              onClick={() => setIsCommittedLoadOpen(!isCommittedLoadOpen)}
              role="button"
            >
              <Row className="align-items-center">
                <Col xs="1">
                  <span className={getChevronIcon(isCommittedLoadOpen)}></span>
                </Col>
                <Col>
                  <span className="text-uppercase">
                    Committed Loads ({filteredCommittedLoad.length})
                  </span>
                </Col>
              </Row>
            </CardHeader>
            <Collapse isOpen={isCommittedLoadOpen}>
              <CardBody>
                {filteredCommittedLoad.map((connection) => (
                  <CommittedLoadConnectionWarning
                    key={connection.enquiryReference}
                    connection={connection}
                  />
                ))}
              </CardBody>
            </Collapse>
          </Card>
        </>
      )}
    </Feature>
  );
};

export default CommittedLoadDisplay;
